export const getAmplitudeDefaultEventProperties = () => {
  // TODO: update correct casing once we update the events in amplitude
  // https://iwoca.atlassian.net/browse/BAE-2904
  return {
    category: 'The Introducer Portal',
    pageName: document.title || '',
    URL: window.location.pathname || '',
  };
};
